import { useState, useContext, useEffect } from 'react';
import MercuryContext from 'ConnectionManager/mercuryContext';
import gql from 'graphql-tag';
import _ from 'lodash';

const queryChildLearnerProgress = gql`
query getSimplifiedProgressReport($cohortId: UUID!, $deploymentId: UUID!, $activityId: UUID!) {
  cohortById(cohortId: $cohortId) {
    id
    enrollments {
      edges {
        node {
          account {
            id
          }
          learnerPerformanceByDeployment(deploymentId: $deploymentId, activityId: $activityId) {
            progress {
              id
              completion {
                value
              }
            }
          }
        }
      }
    }
  }
}
`;

export default function useChildProgress(cohortId, deploymentId, childActivities) {
  const { apolloClient } = useContext(MercuryContext);
  const [errors, setErrors] = useState(null);
  const [data, setData] = useState({});

  useEffect(() => {
    // Clear errors, but persist data
    setErrors(null);

    if (!childActivities) {
      return;
    }

    childActivities.forEach((childActivity) => {
      apolloClient.query({
        query: queryChildLearnerProgress,
        variables: {
          cohortId,
          deploymentId,
          activityId: childActivity.id,
        },
      })
        .then((response) => {
          setData((prevState) => ({
            ...prevState,
            [childActivity.id]: _.chain(response)
              .get('data.cohortById.enrollments.edges')
              .map(({ node }) => node)
              .map((enrollment) => ({
                account: enrollment.account,
                progress: _.get(enrollment, 'learnerPerformanceByDeployment.progress.completion.value'),
              }))
              .value(),
          }));
        })
        .catch((error) => setErrors((prevState = []) => [...prevState, error]));
    });
  }, [apolloClient, cohortId, deploymentId, childActivities]);

  return { errors, data };
}
